import { IconProps } from "./types";
import { SVGIcon } from "./svg-icon";

export const UserGroup = ({
  size,
  type,
  theme,
  className,
  dataTestId = "user-group-icon",
}: IconProps) => (
  <SVGIcon
    size={size}
    type={type}
    theme={theme}
    className={className}
    dataTestId={dataTestId}
  >
    <path d="M14.547 4.57c0 2.528-1.953 4.575-4.363 4.575S5.816 7.098 5.816 4.57C5.816 2.047 7.773 0 10.184 0c2.41 0 4.363 2.047 4.363 4.57Zm-1.457 0c0 1.684-1.3 3.047-2.906 3.047-1.61 0-2.91-1.363-2.91-3.047 0-1.683 1.3-3.047 2.91-3.047 1.605 0 2.906 1.364 2.906 3.047Zm0 0" fillRule="evenodd" />
    <path d="M5.234 1.586c.395-.086.649-.488.57-.899C5.724.274 5.34.007 4.946.09 2.953.516 1.453 2.36 1.453 4.57c0 2.215 1.5 4.059 3.492 4.48.395.087.778-.183.86-.593.078-.414-.176-.816-.57-.898C3.905 7.277 2.91 6.043 2.91 4.57c0-1.472.996-2.703 2.324-2.984Zm0 0" fillRule="nonzero" />
    <path d="M6.324 11.105c.899-.722 2.149-1.199 3.86-1.199 1.707 0 2.957.477 3.855 1.2.89.714 1.371 1.62 1.637 2.386.23.672.066 1.332-.32 1.801-.376.45-.942.707-1.54.707h-7.27a2.002 2.002 0 0 1-1.538-.707 1.852 1.852 0 0 1-.32-1.8c.265-.766.75-1.673 1.636-2.388Zm.887 1.207c-.613.493-.957 1.126-1.152 1.696a.266.266 0 0 0 .046.285.577.577 0 0 0 .442.184h7.27c.206 0 .363-.09.44-.184a.266.266 0 0 0 .048-.285c-.196-.57-.54-1.203-1.153-1.695-.605-.489-1.53-.883-2.968-.883-1.442 0-2.368.394-2.973.883Zm0 0"  fillRule="evenodd" />
    <path d="M1.637 13.926c.148-.602.406-1.235.828-1.703.398-.45.984-.793 1.898-.793.403 0 .727-.344.727-.762 0-.422-.324-.762-.727-.762-1.324 0-2.289.524-2.96 1.274C.75 11.91.41 12.809.23 13.543-.12 14.961 1.027 16 2.184 16h.558c.403 0 .727-.34.727-.762s-.324-.761-.727-.761h-.558a.622.622 0 0 1-.465-.196.381.381 0 0 1-.082-.355Zm0 0" fillRule="nonzero" />
  </SVGIcon>
);
